import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reports")({
  head: () => ({ meta: [{ title: "Reports | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-reports")),
});
